<template>
  <div>
    <Head title="Dashboard" />
    <div class="toolbar">
      <search-filter v-model="form.search" class="w-full max-w-xl" @reset="reset">
      <label class="block text-gray-700" v-if="admin">Assigned To:</label>
      <select v-model="form.assigned_to" v-if="admin" class="form-select mt-1 w-full mb-4">
        <option v-for="user in users" :key="user.id" :value="user.id" :selected="form.assigned_to == user.id">{{ user.name }}</option>
      </select>
      </search-filter>
    </div>

    <h1 class="page-title">Dashboard</h1>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
      <Link href="/orders?status=new" class="metric-card">
        <span class="metric-value">{{tasks.unassigned}}</span>
        <span class="metric-label">New</span>
      </Link>

      <Link href="#sla_breaches" class="metric-card">
        <span v-if="tasks.sla_breaches > 0" class="metric-value text-red-600">{{ tasks.sla_breaches }}</span>
        <span v-else class="metric-value text-green-600">{{ tasks.sla_breaches }}</span>
        <span class="metric-label">SLA Breaches</span>
      </Link>

      <Link href="/orders?status=pending" class="metric-card">
        <span class="metric-value">{{tasks.pending}}</span>
        <span class="metric-label">Pending</span>
      </Link>

      <Link href="/orders?status=hold" class="metric-card">
        <span class="metric-value">{{tasks.followup}}</span>
        <span class="metric-label">On Hold</span>
      </Link>

    </div>
  </div>

  <div class="w-full mt-8 py-3" id="sla_breaches">
    <h2 class="text-lg font-bold text-gray-900">SLA Breaches</h2>
  </div>
  <div class="table-card">
    <table class="data-table">
      <thead>
      <tr class="text-left font-bold">
<!--        <th class="pb-1 pt-6 px-3">-->
<!--          <input id="default-checkbox" v-model="selectAll" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />-->
<!--        </th>-->
        <th>Order ID</th>
        <th>Date/Time</th>
        <th>Name</th>
        <th>Order Value</th>
<!--        <th class="pb-2 pt-6 px-3">Delivery Address</th>-->
        <th>Email</th>
        <th>Phone</th>
        <th>Status</th>
        <th>Followups</th>
        <th v-if="admin">Assigned to</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="order in sla_breaches.data" :key="order.id" class="hover:bg-gray-100 focus-within:bg-gray-100" :id="`order_${order.id}`">
<!--        <td class="border-t  px-3">-->
<!--          <input v-if="order.assigned_to === 0" id="default-checkbox" v-model="selected" :value="order.id" type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />-->
<!--        </td>-->
        <td class="border-t">
          <Link class="flex items-center px-1 focus:text-indigo-500" :href="`/orders/${order.id}`">
            <a href="">{{ order.order_id }}</a>
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-3 focus:text-indigo-500" :href="`/orders/${order.id}`">
            <span v-if="order.sla_breach && (order.status === 'pending' || order.status === 'new' || order.status === 'hold')" class="sla-chip">{{ order.date_time }}</span>
            <span v-else>{{ order.date_time }}</span>
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-3 focus:text-indigo-500" :href="`/orders/${order.id}`">
            {{ order.name }}
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-3" :href="`/orders/${order.id}`" tabindex="-1">
            ₹ {{ order.value }}
          </Link>
        </td>
<!--        <td class="border-t">-->
<!--          <Link class="flex items-center px-3 py-4" :href="`/orders/${order.id}`" tabindex="-1">-->
<!--            {{ order.shipping_address.address_1 }}<br>-->
<!--            <span v-if="order.shipping_address.address_2">{{ order.shipping_address.address_2}}<br></span>-->
<!--            {{ order.shipping_address.city }}<br>-->
<!--            {{ order.shipping_address.state }} {{ order.shipping_address.postcode }}-->
<!--          </Link>-->
<!--        </td>-->
        <td class="border-t">
          <Link class="flex items-center px-3" :href="`/orders/${order.id}`" tabindex="-1">
            {{order.email}}
          </Link>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-3" :href="`/orders/${order.id}`" tabindex="-1">
            {{order.phone_number}}
          </Link>
        </td>
        <td class="border-t">
              <span class="flex items-center px-3">
                <span class="pill_purple" v-if="order.status == 'new'">New</span>
                <span class="pill_blue" v-if="order.status == 'pending'">Pending</span>
                <span class="pill_green" v-if="order.status == 'confirmed'">Confirmed</span>
                <span class="pill_red" v-if="order.status == 'cancelled'">Cancelled</span>
                <span class="pill_yellow" v-if="order.status == 'hold'">On Hold</span>
                <span class="pill_grey" v-if="order.status == 'dispatched'">Dispatched</span>
              </span>
        </td>
        <td class="border-t">
          <Link class="flex items-center px-3" :href="`/orders/${order.id}`" tabindex="-1">
            {{order.followups}}
          </Link>
        </td>
        <td class="border-t" v-if="admin">
          <select :id="`assigned_to_${order.id}`"  v-model="order.assigned_to" :disabled="order.status == 'confirmed' || order.status == 'cancelled'" class="form-select mt-1 w-full" :class="{ 'border-red-400': !order.assigned_to }" v-on:change="assign_user(order.id, order.assigned_to)">
            <option value="0" :selected="!order.assigned_to">None</option>
            <option v-for="user in users" :key="user.id" :value="user.id" :selected="order.assigned_to == user.id">{{user.name}}</option>
          </select>
        </td>
        <td class="w-px border-t">
          <Link class="flex items-center px-4" :href="`/orders/${order.id}`" tabindex="-1">
            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
          </Link>
        </td>
      </tr>
      <tr v-if="sla_breaches.data.length === 0">
        <td class="empty-state" colspan="9">No SLA breaches at the moment.</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import SearchFilter from '@/Shared/SearchFilter'
import {startOfMonth} from 'date-fns'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    Head, Link, SearchFilter,
  },
  layout: Layout,
  props: {
    tasks: Object,
    admin: Boolean,
    sla_breaches: Object,
    users: Array,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        date: this.filters.date ?? [startOfMonth(new Date()), new Date()],
        //status: status,
        assigned_to: null,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },

}
</script>
